const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5001"
    : "https://job.scae.co";

export default API_BASE;